import { render, staticRenderFns } from "./admin-multi-org-employee.vue?vue&type=template&id=1b911789&scoped=true&"
import script from "./admin-multi-org-employee.vue?vue&type=script&lang=js&"
export * from "./admin-multi-org-employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b911789",
  null
  
)

export default component.exports